$(document).on('click', '#menu_open_icon', function() {
  initModal(false)
  $('#modal_icon_user_logo').show()
})
